import { useEffect, useState } from 'react'

import 'aos/dist/aos.css'
import AOS from 'aos'

import alriadh from '../../../assets/images/medinatyy.png'
import tayaraExpo from '../../../assets/images/leshow.png'
import horizon from '../../../assets/images/horizonn.png'
import fondation from '../../../assets/images/fondation.png'
import atelier from '../../../assets/images/atelierr.png'
import paytea from '../../../assets/images/payteaa.png'
import Tayara from '../../../assets/images/tayara.webp'
import luxor from '../../../assets/images/luxor.png'
import almaviva from '../../../assets/images/almaviva.png'
import biat from '../../../assets/images/monrdv.webp'
import freshfx from '../../../assets/images/freshfx.png'
import iPhone from '../../../assets/images/iPhone.png'
import aiagent from '../../../assets/images/urlMind.PNG'
import Ooredoo from '../../../assets/images/Ooredoo.png'
import figmaPlugin from '../../../assets/images/figmaPlugin.png'

import logoFigmaPlugin from '../../../assets/images/logo-figmaPlugin.png'
import logoNacer from '../../../assets/images/logo-nacer.webp'
import logoOoredoo from '../../../assets/images/Ooredoo_logo.png'
import logoIphone from '../../../assets/images/apple.svg'
import logoAiAgent from '../../../assets/images/agent.webp'
import logoalriadh from '../../../assets/images/alriadh-logo.png'
import logotayaraExpo from '../../../assets/images//tayara-logo.webp'
import logohorizon from '../../../assets/images/horizon.png'
import logofondation from '../../../assets/images/fondation.webp'
import logoatelier from '../../../assets/images/atelierLogo.png'
import logopaytea from '../../../assets/images/paytea.png'
import logoTayara from '../../../assets/images/tayara-logo.webp'
import logoluxor from '../../../assets/images/luxor.webp'
import logoalmaviva from '../../../assets/images/almavivaLogo.png'
import logobiat from '../../../assets/images/biatLogo.png'
import logofreshfx from '../../../assets/images/freshFxLogo.png'
import projectsCover from '../../../assets/images/gridd.png'
import { BiRightArrowAlt } from 'react-icons/bi'
import ParticlesCp from '../../ParticlesCp'

export default function MyWorks() {
  const [loading, setLoading] = useState(true)
  // const [showPopupTayaraProject, setShowTayaraProjectPopup] = useState(true)
  var today = new Date()
  var thisYear = today.getFullYear()
  useEffect(() => {
    import('./projects.css')
      .then(() => setLoading(false)) // CSS is imported, stop loading
      .catch(() => setLoading(false)) // In case of error, stop loading as well
  }, [])

  useEffect(() => {
    AOS.init({ duration: 500 })
  }, [])

  const freelanceWorks = [
    {
      title: 'Tayara Marketplace',
      description:
        'Redesigning and Scaling Tunisia`s #1 Marketplace to Millions of Users',
      img: Tayara,
      logoImg: logoTayara,
      link: 'https://nacermediouni.vercel.app/case-studies/tayara',
      descipline: 'UX/UI Design | Frontend',
      Category: 'E-commerce, Marketplace',
      Technologies: 'Next.js, Jotai, Typescript, Tailwind CSS, Figma',
      Availability: 'Figma Available on request',
      AvailabilityPosition: 'bottom-20 -left-6',
      AvailabilityState: 'bg-red-600',
    },
    {
      title: 'Ooredoo Tunisia',
      description:
        'Redesigned a high-traffic telecom mobile app (9M+ downloads)',
      img: Ooredoo,
      logoImg: logoOoredoo,
      link: 'https://nacermediouni.vercel.app/case-studies/ooredoo',
      descipline: 'Product Design',
      Category: 'Telecommunications',
      Availability: 'Figma Available on request',
      AvailabilityPosition: 'bottom-20 -left-6',
      AvailabilityState: 'bg-red-600',

      Technologies: 'Figma, Adobe XD, Maze, Miro, CleverTap',
    },
    {
      title: 'BIAT Bank SaaS',
      description: 'Simplified banking appointments for 1,000+ users every day',

      img: biat,
      logoImg: logobiat,
      link: '/biat',
      descipline: 'UX/UI Design ',
      Category: 'SaaS, Fintech, Banking',
      Technologies: 'Figma',
      Availability: 'Figma Available',
      AvailabilityPosition: 'bottom-10 -left-0',
      AvailabilityState: 'bg-green-600',
    },

    {
      title: 'Almaviva Visa Services',

      description: 'Simplified visa application UX for 15K+ monthly visitors',
      img: almaviva,
      logoImg: logoalmaviva,
      link: '/almaviva',
      descipline: 'UX/UI Design ',
      Category: 'Visa services',
      Technologies: 'Figma',
      Availability: 'Figma Available',
      AvailabilityPosition: 'bottom-10 -left-0',

      AvailabilityState: 'bg-green-600',
    },

    {
      title: 'FFX SaaS Dashboard',

      description:
        'Delivered real-time performance analytics for athletes and coaches',
      img: freshfx,
      logoImg: logofreshfx,
      link: '/freshFxDashboard',
      descipline: 'UX/UI Design',
      Category: 'Sports',
      Technologies: 'Figma',
      Availability: 'Figma Available',
      AvailabilityPosition: 'bottom-10 -left-0',

      AvailabilityState: 'bg-green-600',
    },

    {
      title: 'Fondation',

      description: `Amplified NGO impact for 61K+ youth across 3.5K+ trainings
`,
      img: fondation,
      logoImg: logofondation,
      link: '/fondation',
      descipline: 'UX/UI Design | Frontend',
      Category: 'Non-profit',
      Technologies: 'Figma, Gatsby.js, Strapi',
      Availability: 'Figma Available',
      AvailabilityPosition: 'bottom-10 -left-0',

      AvailabilityState: 'bg-green-600',
    },
  ]

  const otherWorks = [
    {
      title: 'Paytea HR SaaS',
      description:
        'A cloud-based HR management SaaS designed to streamline internal agency operations.',
      img: paytea,
      logoImg: logopaytea,
      link: '/paytea',
      descipline: 'UX/UI Design',
      Category: 'SaaS',
      Technologies: 'Figma (UI Design)',
      Availability: 'Figma Available',
      AvailabilityPosition: 'bottom-10 -left-0',

      AvailabilityState: 'bg-green-600',
    },
    {
      title: 'Tayara Expo',

      description:
        "The official website for Tunisia's first Tayara Car Exhibition offers comprehensive information about the event, including schedules and exhibitor details.",
      img: tayaraExpo,
      logoImg: logotayaraExpo,
      link: 'https://le-show-de-lautomobile.vercel.app/',
      descipline: 'UX/UI Design | Frontend',
      Category: 'Events',
      Technologies: 'Next.js, Typescript, Tailwind CSS.',
      Availability: 'Figma Available',
      AvailabilityPosition: 'bottom-10 -left-0',

      AvailabilityState: 'bg-green-600',
    },

    {
      title: 'Madinaty',
      description:
        'A landing page that aims to highlight the Madinaty app produced by the Riyadh Municipality in the Kingdom of Saudi Arabia. This app is a gateway to the capital city of Riyadh, offering a range of e-services designed to enhance accessibility and convenience.',
      img: alriadh,
      logoImg: logoalriadh,
      link: 'https://alriadh-landing-page.netlify.app/',
      descipline: 'Frontend',
      Category: 'Saudi Arabia Government e-services',
      Technologies: 'ReactJS, CSS',
      Availability: 'Figma Available',
      AvailabilityPosition: 'bottom-10 -left-0',

      AvailabilityState: 'bg-green-600',
    },

    {
      title: 'Horizon',

      description: `The UGPO website supports Tunisian scientific excellence through the European Horizon 2020 Research and Innovation Program.`,
      img: horizon,
      logoImg: logohorizon,
      link: 'https://www.horizon-europe.tn/',
      descipline: 'Frontend',
      Category: 'Research and Innovation',
      Technologies: 'ReactJS, Strapi',
      AvailabilityPosition: 'bottom-20 -left-6',
      Availability: 'Figma Available on request',
      AvailabilityState: 'bg-red-600',
    },
    {
      title: 'Luxor',

      description: `
  The Luxor Technology and Trade (LTT) website showcases the commercial and development arm of the Luxor group, established in 1999. LTT specializes in innovative technical solutions for the construction industry, including cement, concrete, architectural concrete, and repair.`,
      img: luxor,
      logoImg: logoluxor,
      link: 'https://luxor.com.tn/en/',
      descipline: 'Frontend',
      Category: 'Construction industry',
      Technologies: 'ReactJS, Gatsby, Strapi',
      Availability: 'Figma Available on request',
      AvailabilityPosition: 'bottom-20 -left-6',
      AvailabilityState: 'bg-red-600',
    },
    {
      title: 'Atelier',

      description:
        "A website to showcase the agency's architectural services and portfolio.",
      img: atelier,
      logoImg: logoatelier,
      link: '/atelier',
      descipline: 'UI/UX | Frontend',
      Category: 'Architectural services and portfolio',
      Technologies: 'Figma (UI Design) Gatsby.js, CSS (Front-end)',
      Availability: 'Figma Available',
      AvailabilityPosition: 'bottom-10 -left-0',

      AvailabilityState: 'bg-green-600',
    },
  ]

  const sideProjects = [
    {
      title: 'Figma plugin',
      description:
        'With just a few clicks, generate color scales, create variables, and export ready-to-use styles, perfect for building design systems.',
      img: figmaPlugin,
      logoImg: logoFigmaPlugin,
      link: 'https://www.figma.com/community/plugin/1547688404510661526/color-palette-generator/',
      descipline: 'UX/UI Design',
      Category: 'Showcasing',
      Technologies: 'Figma Plugin API, Javascript, HTML, CSS',
    },
    {
      title: '3D iPhone 15 website',
      description:
        'This is a clone of Apple`s iPhone 15 Pro website using React.js and TailwindCSS. It highlights the effective use of GSAP (Greensock Animations) and Three.js for displaying iPhone 15 Pro models in various colors and shapes.',
      img: iPhone,
      logoImg: logoIphone,
      link: 'https://3d-iphone-showcasing-website.vercel.app/',
      descipline: 'Frontend',
      Category: 'Showcasing',
      Technologies:
        'React.js, Three.js, React Three Fiber, React Three Drei, GSAP (Greensock), Vite, Tailwind CSS',
    },
    {
      title: 'URL AI Mind',
      description:
        'A Web app allows users to input a URL and chat with an AI about the site`s content. The AI understands the page and provides context-driven responses, helping users explore and interact with the website more effectively.',
      img: aiagent,
      logoImg: logoAiAgent,
      link: 'https://url-ai-mind.netlify.app/',
      descipline: 'Frontend',
      Category: 'Showcasing',
      Technologies: 'Next.js, GSAP (Greensock), Tailwind CSS',
    },
  ]

  return (
    <div className="">
      <ParticlesCp />

      {/* {showPopupTayaraProject && (
        <div
          class="showpopup"
          onClick={(e) => {
            if (e.target !== e.currentTarget) return
            handleCloseOnboardingTayaraProject()
          }}
        >
          <img
            src={pinchtozoom}
            alt="pinch to zoom project images"
            className="NavigationGuide"
          />
          <button onClick={() => handleCloseOnboardingTayaraProject()}>
            Skip
          </button>
        </div>
      )} */}
      {loading ? (
        <div class="spinner-wrap-on-loading">
          <div className="loading-container">
            <img className="logo-on-loading" src={logoNacer} alt="" />
            <div class="spinner-item"></div>
            <div class="spinner-item spinner-item--2"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-black font-sans overflow-hidden">
            <header class="header">
              <a href="https://nacermediouni.vercel.app/">
                <img class="logo" src={logoNacer} alt="" />
              </a>
            </header>

            {/* <span className="rotate-90 w-1 h-10 bg-slate-300"></span> */}
            <div class="mai-title mt-10 right-4 md:right-16 md:mt-0 ">
              <h2>
                <span className="!text-[2rem] lg:!text-5xl">Projects</span>
                <span class="bg-text !text-[3rem] lg:!text-7xl">portfolio</span>
              </h2>
            </div>

            {/* <div
              class="fixed w-full h-screen bg-auto !bg-center  bg-no-repeat"
              style={{
                backgroundImage: `url(${grid})`,
              }}
            ></div> */}

            <div
              class="fixed w-full h-screen bg-cover lg:bg-cover bg-center  bg-no-repeat"
              style={{
                backgroundImage: `url(${projectsCover})`,
              }}
            ></div>

            <nav className="lg:contents  w-full h-full hidden">
              <div
                orientation="left"
                className="side__StyledSideElement-sc-1duznzb-0 hOvuuP"
              >
                <ul class="social__StyledSocialList-anu6nt-0 dVLQAC fade-enter-done">
                  <li>
                    <a
                      href="https://github.com/Nacer-MEDIOUNI"
                      aria-label="GitHub"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-github"
                      >
                        <title>GitHub</title>
                        <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/nacermedi/"
                      aria-label="Instagram"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-instagram"
                      >
                        <title>Instagram</title>
                        <rect
                          x="2"
                          y="2"
                          width="20"
                          height="20"
                          rx="5"
                          ry="5"
                        ></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/nacermediouni/"
                      aria-label="Linkedin"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-linkedin"
                      >
                        <title>LinkedIn</title>
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                        <rect x="2" y="9" width="4" height="12"></rect>
                        <circle cx="4" cy="4" r="2"></circle>
                      </svg>
                    </a>
                  </li>
                  <li></li>
                </ul>
              </div>

              <div
                orientation="left"
                class="side__StyledSideElement-sc-1duznzb-0 sideGmail"
              >
                <ul class="social__StyledSocialList-anu6nt-0 gmail fade-enter-done">
                  <li>
                    <a href="mailto:nacer.mediouni@gmail.com">
                      nacer.mediouni@gmail.com
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
            <div className="absolute md:fixed rotate-0 md:rotate-90 top-11 md:top-[86%] lg:top-[50%] right-7 md:right-0 lg:right-[2%] flex flex-col z-[9999]  w-fit h-fit">
              <a
                className=" flex gap-1 items-center text-base lg:text-xl font-semibold  lg:font-bold  text-white text-neutral-500 "
                href="/about"
              >
                About me
                <BiRightArrowAlt className="block md:hidden" size={20} />
              </a>
              <span className="relative left-10 bottom-3 rotate-90 w-[1px] h-10 bg-[#00ffc6]"></span>
            </div>

            <div className=" w-full h-full  max-w-[1400px] mx-auto bg-no-repeat bg-fixed  bg-center ">
              <div className="h-full z-10 w-full bg-[#0A0B13] ">
                <div className="w-full h-full flex flex-col items-center justify-center gap-6 pb-10 pt-36 lg:pt-48 ">
                  <div className="w-full px-6 lg:px-[12%] pt-14 lg:pt-0 lg:pb-10 justify-center items-center">
                    {/* <h2 className="fixed rotate-[270deg]  md:-left-[10%] font-black text-white/20 top-[50%] lg:top-[40%] text-9xl md:text-[10rem] mt-10  md:mt-0">
                      Portfolio
                    </h2> */}
                    {/* <div class=" relative mb-6">
                      <h1 className="text-xl md:text-5xl font-bold  mb-6 md:my-10 text-start md:text-start">
                        Case studies
                      </h1>
                    </div> */}
                    {/* <h1 className="relative w-fit font-extrabold text-lg md:text-3xl my-6 md:mt-10 md:mb-20 text-start md:text-start ">
                      Driving measurable impact across diverse industries, from
                      telecom and fintech to marketplaces and non-profits.
                    </h1> */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-20 gap-y-20 lg:justify-items-end md:mx-0">
                      {freelanceWorks.map((work, index) => (
                        <div
                          key={index}
                          className="relative lg:w-full h-[20rem] lg:h-[24rem] rounded-xl border-[1px] border-white/30  bg-no-repeat bg-gray-400 bg-cover bg-right lg:bg-left "
                          data-aos="fade-up"
                          data-aos-delay={index * 10}
                          style={{
                            backgroundImage: `url(${work.img})`,
                            marginTop: index % 2 === 1 ? '18px' : '0px',
                          }}
                        >
                          <div className="w-full h-full gap-4 flex justify-center items-center flex-col">
                            <div
                              className="absolute top-4 left-4 w-10 h-10 rounded-full z-[55] bg-white/50 backdrop-blur-sm flex items-center justify-center bg-no-repeat bg-contain bg-center transition duration-300"
                              style={{
                                backgroundImage: `url(${work.logoImg})`,
                                padding: '6px',
                                backgroundOrigin: 'content-box',
                              }}
                            >
                              {/* <img
                                className=" w-24 object-contain"
                                src={work.logoImg}
                                alt={work.title}
                              /> */}
                            </div>
                            <div className="absolute bottom-4 right-4 w-fit h-fit p-3 bg-black/50  z-[55] backdrop-blur-sm rounded-xl flex items-center justify-center transition duration-300">
                              <p className="text-white text-xs uppercase font-semibold">
                                {work.descipline}
                              </p>
                            </div>
                            <div className="absolute top-6 right-4 w-fit h-fit p-3 bg-black/50  z-[55] backdrop-blur-sm rounded-xl flex items-center justify-center transition duration-300">
                              <p className="text-white text-xs uppercase font-semibold">
                                {work.Category}
                              </p>
                            </div>

                            <div className="absolute bottom-4 left-4 w-fit h-fit p-3 bg-black/50  z-[55] backdrop-blur-sm rounded-xl flex items-center justify-center transition duration-300">
                              <span
                                className={`${work.AvailabilityState} mr-1 p-1 rounded-full`}
                              />
                              <p className="text-white text-xs lg:text-sm font-semibold">
                                {work.Availability}
                              </p>
                            </div>
                            <div className="absolute bottom-4 right-4 w-fit h-fit p-3 bg-black/50  z-[55] backdrop-blur-sm rounded-xl flex items-center justify-center transition duration-300">
                              <p className="text-white text-xs uppercase font-semibold">
                                {work.descipline}
                              </p>
                            </div>
                            {/* Overlay to create blur effect */}
                            <a
                              href={work.link}
                              rel="noreferrer"
                              // target="_blank"
                            >
                              <div className="absolute inset-0 bg-black/80 rounded-xl border-[1px] border-white backdrop-blur-sm hover:opacity-0 opacity-100 transition duration-300 z-50">
                                {/* Text that appears on hover */}
                                <div className="relative top-20 flex flex-col items-start justify-center hover:opacity-0 opacity-100 transition duration-300">
                                  <h2 className=" text-start w-full text-3xl lg:text-4xl/normal px-7  font-extrabold">
                                    {work.description}
                                  </h2>
                                  {/* <p className="text-[12px] md:text-[14px] lg:text-base font-medium ml-6 mr-8 mt-0 lg:mt-4">
                                    {work.description}
                                  </p> */}
                                  {/* <ExpandableParagraph
                                    text={work.description}
                                  /> */}
                                  {/* <p className="text-[12px] md:text-[14px] lg:text-base font-normal ml-6 mr-8 mt-0 lg:mt-4">
                                    Technologies : {work.Technologies}
                                  </p> */}
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="flex w-full justify-start items-center">
                            <span className="rotate-90 w-1 h-9 bg-white"></span>
                            <p className="text-white text-xl my-4 font-bold uppercase tracking-widest">
                              {work.title}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <h1
                      className="relative w-5/6 font-extrabold text-3xl mt-28 mb-20 md:my-32 text-start "
                      data-aos="fade-up"
                      data-aos-delay={40}
                    >
                      {' '}
                      Other Freelance Projects
                    </h1>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-20 gap-y-20 lg:justify-items-end md:mx-0">
                      {otherWorks.map((work, index) => (
                        <div
                          key={index}
                          className="relative lg:w-full h-[20rem] lg:h-[24rem] rounded-xl border-[1px] border-white/30  bg-no-repeat bg-gray-400 bg-cover bg-right lg:bg-left "
                          data-aos="fade-up"
                          data-aos-delay={index * 10}
                          style={{
                            backgroundImage: `url(${work.img})`,
                            marginTop: index % 2 === 1 ? '18px' : '0px',
                          }}
                        >
                          <div className="w-full h-full gap-4 flex justify-center items-center flex-col">
                            <div
                              className="absolute top-4 left-4 w-10 h-10 rounded-full z-[55] bg-white/50 backdrop-blur-sm flex items-center justify-center bg-no-repeat bg-contain bg-center transition duration-300"
                              style={{
                                backgroundImage: `url(${work.logoImg})`,
                                padding: '6px',
                                backgroundOrigin: 'content-box',
                              }}
                            >
                              {/* <img
                                className=" w-24 object-contain"
                                src={work.logoImg}
                                alt={work.title}
                              /> */}
                            </div>
                            <div className="absolute bottom-4 right-4 w-fit h-fit p-3 bg-black/50  z-[55] backdrop-blur-sm rounded-xl flex items-center justify-center transition duration-300">
                              <p className="text-white text-xs uppercase font-semibold">
                                {work.descipline}
                              </p>
                            </div>
                            <div className="absolute top-4 right-4 w-fit h-fit p-3 bg-black/50  z-[55] backdrop-blur-sm rounded-xl flex items-center justify-center transition duration-300">
                              <p className="text-white text-xs uppercase font-semibold">
                                {work.Category}
                              </p>
                            </div>
                            {/* Overlay to create blur effect */}
                            <div className="absolute inset-0 bg-black/80 rounded-xl border-[1px] border-white backdrop-blur-sm opacity-0 hover:opacity-100 transition duration-300 z-50">
                              {/* Text that appears on hover */}

                              <a
                                href={work.link}
                                rel="noreferrer"
                                // target="_blank"
                              >
                                <div className="absolute inset-0 flex flex-col items-start justify-center opacity-0 hover:opacity-100 transition duration-300">
                                  <h2 className="text-transparent text-[28px] text-end md:text-start w-full md:text-4xl lg:text-4xl -ml-2 md:ml-6 stroke-text font-semibold">
                                    {work.title}
                                  </h2>
                                  <p className="text-[12px] md:text-[14px] lg:text-base font-medium ml-6 mr-8 mt-0 lg:mt-4">
                                    {work.description}
                                  </p>
                                  {/* <ExpandableParagraph
                                    text={work.description}
                                  /> */}
                                  <p className="text-[12px] md:text-[14px] lg:text-base font-normal ml-6 mr-8 mt-0 lg:mt-4">
                                    Technologies : {work.Technologies}
                                  </p>
                                </div>
                              </a>
                            </div>
                          </div>
                          <div className="flex w-full justify-start items-center">
                            <span className="rotate-90 w-1 h-9 bg-white"></span>
                            <p className="text-white text-xl my-4 font-bold uppercase tracking-widest">
                              {work.title}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <h1
                      className="relative w-full mr-20 font-extrabold text-4xl md:text-5xl mt-24 lg:mt-32 mb-16 text-end"
                      data-aos="fade-up"
                      data-aos-delay={10}
                    >
                      Not only that!
                    </h1>
                    {/* <h1
                      className="relative md:mx-10 font-extrabold text-lg md:text-3xl my-20 text-start"
                      data-aos="fade-up"
                      data-aos-delay={20}
                    >
                      Also, as a mentor...
                    </h1> */}
                    {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-20 gap-y-20 lg:justify-items-end md:mx-0 lg:md:mx-10">
                      {otherWorks.map((work, index) => (
                        <div
                          key={index}
                          className="relative lg:w-full h-[20rem] lg:h-[24rem] rounded-xl border-[1px] border-white/30  bg-no-repeat bg-gray-400 bg-cover bg-right lg:bg-left "
                          data-aos="fade-up"
                          data-aos-delay={index * 10}
                          style={{
                            backgroundImage: `url(${work.img})`,
                            marginTop: index % 2 === 1 ? '18px' : '0px',
                          }}
                        >
                          <div className="w-full h-full gap-4 flex justify-center items-center flex-col">
                            <div
                              className="absolute top-4 left-4 w-10 h-10 rounded-full z-[55] bg-white/50 backdrop-blur-sm flex items-center justify-center bg-no-repeat bg-contain bg-center transition duration-300"
                              style={{
                                backgroundImage: `url(${work.logoImg})`,
                                padding: '6px',
                                backgroundOrigin: 'content-box',
                              }}
                            >
                            </div>
                            <div className="absolute bottom-4 right-4 w-fit h-fit p-3 bg-black/20  z-[55] backdrop-blur-sm rounded-xl flex items-center justify-center transition duration-300">
                              <p className="text-white text-xs uppercase font-semibold">
                                {work.descipline}
                              </p>
                            </div>
                            <div className="absolute inset-0 bg-black/80 rounded-xl border-[1px] border-white backdrop-blur-sm opacity-0 hover:opacity-100 transition duration-300 z-50">
                              <a
                                href={work.link}
                                rel="noreferrer"
                              >
                                <div className="absolute inset-0 flex flex-col items-start justify-center opacity-0 hover:opacity-100 transition duration-300">
                                  <h2 className="text-transparent text-[28px] text-end md:text-start w-full md:text-4xl lg:text-4xl -ml-2 md:ml-6 stroke-text font-semibold">
                                    {work.title}
                                  </h2>
                                  <p className="text-[14px] lg:text-base font-medium ml-6 mr-8 mt-0 lg:mt-4">
                                    {work.description}
                                  </p>
                                </div>
                              </a>
                            </div>
                          </div>
                          <div className="flex w-full justify-start items-center">
                            <span className="rotate-90 w-1 h-9 bg-white"></span>
                            <p className="text-white text-xl my-4 font-bold uppercase tracking-widest">
                              {work.title}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div> */}

                    <h1
                      className="relative w-5/6 font-extrabold text-3xl mt-28 mb-20 lg:mt-20 text-start "
                      data-aos="fade-up"
                      data-aos-delay={40}
                    >
                      {' '}
                      Here are some of my side projects!
                    </h1>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-20 gap-y-20 lg:justify-items-end md:mx-0">
                      {sideProjects.map((work, index) => (
                        <div
                          key={index}
                          className="relative lg:w-full h-[20rem] lg:h-[24rem] rounded-xl border-[1px] border-white/30  bg-no-repeat bg-gray-400 bg-cover bg-right lg:bg-left "
                          data-aos="fade-up"
                          data-aos-delay={index * 10}
                          style={{
                            backgroundImage: `url(${work.img})`,
                            marginTop: index % 2 === 1 ? '18px' : '0px',
                          }}
                        >
                          <div className="w-full h-full gap-4 flex justify-center items-center flex-col">
                            <div
                              className="absolute top-4 left-4 w-10 h-10 rounded-full z-[55] bg-white/50 backdrop-blur-sm flex items-center justify-center bg-no-repeat bg-contain bg-center transition duration-300"
                              style={{
                                backgroundImage: `url(${work.logoImg})`,
                                padding: '6px',
                                backgroundOrigin: 'content-box',
                              }}
                            >
                              {/* <img
                                className=" w-24 object-contain"
                                src={work.logoImg}
                                alt={work.title}
                              /> */}
                            </div>
                            <div className="absolute bottom-4 right-4 w-fit h-fit p-3 bg-black/50  z-[55] backdrop-blur-sm rounded-xl flex items-center justify-center transition duration-300">
                              <p className="text-white text-xs uppercase font-semibold">
                                {work.descipline}
                              </p>
                            </div>
                            <div className="absolute top-4 right-4 w-fit h-fit p-3 bg-black/50  z-[55] backdrop-blur-sm rounded-xl flex items-center justify-center transition duration-300">
                              <p className="text-white text-xs uppercase font-semibold">
                                {work.Category}
                              </p>
                            </div>
                            {/* Overlay to create blur effect */}
                            <div className="absolute inset-0 bg-black/80 rounded-xl border-[1px] border-white backdrop-blur-sm opacity-0 hover:opacity-100 transition duration-300 z-50">
                              {/* Text that appears on hover */}

                              <a
                                href={work.link}
                                rel="noreferrer"
                                // target="_blank"
                              >
                                <div className="absolute inset-0 flex flex-col items-start justify-center opacity-0 hover:opacity-100 transition duration-300">
                                  <h2 className="text-transparent text-[28px] text-end md:text-start w-full md:text-4xl lg:text-4xl -ml-2 md:ml-6 stroke-text font-semibold">
                                    {work.title}
                                  </h2>
                                  <p className="text-[12px] md:text-[14px] lg:text-base font-medium ml-6 mr-8 mt-0 lg:mt-4">
                                    {work.description}
                                  </p>
                                  {/* <ExpandableParagraph
                                    text={work.description}
                                  /> */}
                                  <p className="text-[12px] md:text-[14px] lg:text-base font-normal ml-6 mr-8 mt-0 lg:mt-4">
                                    Technologies : {work.Technologies}
                                  </p>
                                </div>
                              </a>
                            </div>
                          </div>
                          <div className="flex w-full justify-start items-center">
                            <span className="rotate-90 w-1 h-9 bg-white"></span>
                            <p className="text-white text-xl my-4 font-bold uppercase tracking-widest">
                              {work.title}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>

                    <h1
                      className="relative w-5/6 font-extrabold text-3xl mt-28 mb-20 md:my-32 text-start "
                      data-aos="fade-up"
                      data-aos-delay={40}
                    >
                      You can find more of my side projects in{' '}
                      <a
                        href="https://github.com/Nacer-MEDIOUNI"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-transparent underline underline-offset-3 underline-offset-1  text-[#00ffc6] "
                      >
                        my github account
                      </a>
                      , which I used to learn and practice!
                    </h1>
                  </div>

                  <h1
                    className="relative w-fit font-extrabold text-xl md:text-4xl mb-0 mt-36 md:mt-20 text-center "
                    data-aos="fade-up"
                    data-aos-delay={40}
                  >
                    {' '}
                    Want to build remarkable products together?
                  </h1>
                  <a
                    href="https://www.linkedin.com/in/nacermediouni/"
                    aria-label="Linkedin"
                    target="_blank"
                    rel="noreferrer"
                    className="relative text-2xl lg:text-3xl text-[#00ffc6] font-bold underline underline-offset-2 underline-offset-1"
                  >
                    Let's get strated!
                  </a>
                  {/* <ContactFormModal /> */}
                </div>
                <p className="relative z-[9999] text-white text-sm py-8 text-center">
                  Designed and built by me &copy; {thisYear} All rights
                  reserved.
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
